import { USERS_ACTIONS } from "../constants/action-types";

const initialState = {
  user: [],
  status: false,
  message: "",
  saveStatus: false,
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case USERS_ACTIONS.USERS_LOADING:
      return Object.assign({}, state, {
        user: [],
        status: false,
        message: "",
      });
    case USERS_ACTIONS.USERS_LOADED:
      return Object.assign({}, state, {
        user: action.payload.user,
        status: true,
        message: "",
      });
    case USERS_ACTIONS.USERS_ERROR:
      return Object.assign({}, state, {
        user: [],
        status: false,
        message: action.payload,
      });
    case USERS_ACTIONS.USER_REGISTER_START:
      return Object.assign({}, state, {
        saveStatus: false,
      });
    case USERS_ACTIONS.USER_REGISTER_SUCCESS:
      return Object.assign({}, state, {
        saveStatus: true,
      });
    case USERS_ACTIONS.USER_REGISTER_ERROR:
      return Object.assign({}, state, {
        saveStatus: false,
        message: action.payload,
      });
    default:
      return state;
  }
};

export default usersReducer;
